export default {"src":"/_next/static/media/powerpoint-doc.297459ef.svg","height":40,"width":40};